import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function PaymentCancelledPage() {
  const [searchParams] = useSearchParams();
  const invoiceId = searchParams.get("invoiceId");

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-2xl flex-col items-center">
        <div className="w-full rounded-3xl border border-amber-200 bg-white p-8 shadow-sm sm:p-10">
          <div className="mb-6 flex justify-center">
            <div className="rounded-full bg-amber-50 p-4 text-amber-600">
              <AlertCircle className="h-12 w-12" />
            </div>
          </div>

          <div className="text-center">
            <h1 className="text-3xl font-semibold text-slate-900">Payment Cancelled</h1>
            <p className="mt-4 text-base text-slate-600">
              Your payment was cancelled before completion. No charges were made.
            </p>

            {invoiceId ? (
              <div className="mt-6 rounded-2xl border border-strivre-lightnavy bg-slate-50 p-4">
                <p className="text-sm font-medium text-slate-600">Invoice ID</p>
                <p className="mt-1 break-all text-base font-semibold text-slate-900">{invoiceId}</p>
              </div>
            ) : null}

            <div className="mt-8">
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700"
              >
                Return Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
